import React from "react";
import { company } from "../data/content";

function TopBar() {
  return (
    <div className="topbar">
      <div className="container topbar-inner">
        <span className="topbar-note">
          <i className="fa-solid fa-location-dot" aria-hidden="true" /> Pathum Thani, Bangkok Metropolitan Area · Serving clients locally and internationally
        </span>
        <div className="topbar-links">
          <a href={`mailto:${company.email}`}>
            <i className="fa-solid fa-envelope" aria-hidden="true" /> {company.email}
          </a>
          <a href={company.officePhone.href}>
            <i className="fa-solid fa-phone" aria-hidden="true" /> {company.officePhone.label}
          </a>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
